import React from 'react';
import AdminRoute from './pages/AdminRoute';

const App: React.FC = () => <AdminRoute />;

export default App;
